import { IconWrapper } from '../runtime';
export default IconWrapper('word-wrap', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M14.25 5.99976V3.24976C14.25 2.42133 13.5784 1.74976 12.75 1.74976H3.25C2.42157 1.74976 1.75 2.42133 1.75 3.24976V12.7498C1.75 13.5782 2.42157 14.2498 3.25 14.2498H5M14.25 7.49976V12.7498C14.25 13.5782 13.5784 14.2498 12.75 14.2498H9",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.25 9.24976H10.75M5.25 5.74976H10.75",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M7.5 14.2498L9.25 12.4998V14.2498H7.5Z",
      "fill": props.colors[0],
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});